import React,{useEffect,useRef} from "react";
import Swiper from 'swiper';
import { Autoplay, Navigation,Pagination  } from "swiper/modules";
import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";

const Demo = () => {
    const swiperRef = useRef(null);
    
    useEffect(() => {
        const swiper =   new Swiper('.swiper-container', {
            modules: [Autoplay, Navigation,Pagination ],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
   
          loop: false,
          spaceBetween: -1,
          slidesPerView: 4,
          autoplay: {
            delay: 2500, // Slide changes every 3 seconds
            disableOnInteraction: false, // Keeps autoplay running even after user interaction
          },
          speed: 2000,
          breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: -20,
            },
        },
        });

        swiperRef.current = swiper;

        const swiperContainer = document.querySelector(".swiper-container");
    
        const handleMouseEnter = () => {
            if (swiperRef.current) swiperRef.current.autoplay.stop();
          };
      
          const handleMouseLeave = () => {
            if (swiperRef.current) swiperRef.current.autoplay.start();
          };    
      
        //   // Add event listeners
          swiperContainer.addEventListener("mouseenter", handleMouseEnter);
          swiperContainer.addEventListener("mouseleave", handleMouseLeave);
      
          // Cleanup on unmount
          return () => {
            swiperContainer.removeEventListener("mouseenter", handleMouseEnter);
            swiperContainer.removeEventListener("mouseleave", handleMouseLeave);
            swiperRef.current?.destroy();
          };
      }, []);
    return (
        <div className="elementor-element elementor-element-327b243 e-con-full e-flex e-con e-parent e-lazyloaded" data-id="327b243" data-element_type="container">
            <div className="elementor-element elementor-element-5e63ef9 elementor-widget elementor-widget-startpro_core_process_info_tabs" data-id="5e63ef9" data-element_type="widget" data-widget_type="startpro_core_process_info_tabs.default">
                <div className="elementor-widget-container ">
                    <div className="swiper-container  qodef-shortcode qodef-m  qodef-process-info-tabs qodef-layout--gradient-overlay qodef-retina-scaling--yes qodef-enable-min-height--yes  qodef-items--4 qodef-grid qodef-layout--columns qodef-col-num--4 qodef-gutter--no qodef-vertical-gutter--no qodef-responsive--custom qodef-col-num--1512--4 qodef-col-num--1368--4 qodef-col-num--1200--2 qodef-col-num--1024--2 qodef-col-num--880--2 qodef-col-num--680--1 swiper-height" style={{overflow:"hidden"}} >
                    {/* qodef-grid-inner */}
                        <div className="swiper-wrapper  qodef-process-info-tabs-holder" style={{display:"flex"}}>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/World-Trade.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                       
                                    }}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 100%) ,rgba(96, 96, 96, 0%),rgba(0, 0, 0, 100%) ), url(/projectsimg/wtc-featured.jpg)`}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(/projectsimg/wtc-featured.jpg)`}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/world-trade-centre"
                                                target="_self"
                                            >
                                              
                                                <br />World Trade Center
                                                <br /> Muscat{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/world-trade-centre"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                                                                           
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/Ahli-Bank-Head.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                       
                                    }}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 100%) ,rgba(96, 96, 96, 0%),rgba(0, 0, 0, 100%) ), url(/projectsimg/wtc-featured.jpg)`}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(/projectsimg/wtc-featured.jpg)`}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/ahli-bank-head-office-building-wattayah"
                                                target="_self"
                                            >
                                              
                                                <br />Ahli Bank Head Office Building,
                                                <br />  Wattayah{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/ahli-bank-head-office-building-wattayah"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/Hai-Al-Naseem.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                       
                                    }}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 100%) ,rgba(96, 96, 96, 0%),rgba(0, 0, 0, 100%) ), url(/projectsimg/wtc-featured.jpg)`}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(/projectsimg/wtc-featured.jpg)`}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/hai-al-naseem"
                                                target="_self"
                                            >
                                              
                                                <br />Hai Al Naseem,
                                                <br />Barka{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/hai-al-naseem"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/snow-park-01.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                    }}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/snow-park-mall-of-muscat"
                                                target="_self"
                                            >
                                             
                                                <br /> Snow Park
                                                <br /> Mall of Muscat{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/snow-park-mall-of-muscat"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/Bait-Al-Reem-Business-Centre.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                       
                                    }}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 100%) ,rgba(96, 96, 96, 0%),rgba(0, 0, 0, 100%) ), url(/projectsimg/wtc-featured.jpg)`}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(/projectsimg/wtc-featured.jpg)`}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/bait-al-reem"
                                                target="_self"
                                            >
                                              
                                                <br />Bait Al Reem – Business Centre,
                                                <br /> Ministries District{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/bait-al-reem"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                           
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/Sohar-China.png)",
                                        padding: "9%",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        transition: "background 0.3s ease-in-out",
                                       
                                    }}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 100%) ,rgba(96, 96, 96, 0%),rgba(0, 0, 0, 100%) ), url(/projectsimg/wtc-featured.jpg)`}
                                    // onMouseLeave={(e) => e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(/projectsimg/wtc-featured.jpg)`}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/sohar-china-downtown"
                                                target="_self"
                                            >
                                              
                                                <br />Sohar China 
                                                <br />Downtown{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/sohar-china-downtown"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                               
                                </div>
                            </div>
                          
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/oman-aquarium-01.png)",
                                        padding: "9%"
                                    }}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/anantara-resort-hotel-spa"
                                                target="_self"
                                            >
                                              
                                                <br /> Anantara Resort
                                                <br /> Hotel &amp; Spa{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/anantara-resort-hotel-spa"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/mall-of-muscat-01.png)",
                                        padding: "9%"
                                    }}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/mall-of-muscat"
                                                target="_self"
                                            >
                                                
                                                <br />Mall of
                                                <br /> Muscat{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/mall-of-muscat"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="swiper-slide qodef-grid-item qodef-process-info-tabs-item-holder">
                                <div
                                    className="qodef-process-info-tabs-item qodef-item-skin--light qodef--has-appear qodef--appear-fade qodef--appeared"
                                    style={{
                                        backgroundImage:
                                            "url(/projectsimg/anantara-resort.png)",
                                        padding: "9%"
                                    }}
                                >
                                    <div className="qodef-process-info-tabs-content">
                                        <h4 className="qodef-e-title entry-title" style={{fontSize:"20px"}}>
                                            <a
                                               
                                                href="/projects/alila-Salalah-Hotel"
                                                target="_self"
                                            >
                                               
                                                <br /> Alila Salalah Hotel
                                                <br /> Resort/ Hinubay Mirbat{" "}
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="qodef-process-info-tabs-content-bottom">
                                        <div className="qodef-m-button">
                                            <a
                                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--outlined-revealing  qodef-html--link qodef-reveal-direction--right "
                                                href="/projects/alila-Salalah-Hotel"
                                                target="_self"
                                            >
                                                {" "}
                                                <span className="qodef-border-holder qodef-border-1" />{" "}
                                                <span className="qodef-hidden-content">
                                                    {" "}
                                                    <span className="qodef-m-text">Read more</span>{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>{" "}
                                                <span className="qodef-initial-arrow">
                                                    {" "}
                                                    <span className="qodef-border-holder qodef-border-2" />{" "}
                                                    <svg
                                                        className="qodef-svg--button-arrow"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        x="0px"
                                                        y="0px"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 9 9"
                                                        style={{ enableBackground: "new 0 0 9 9", fill: "currentColor" }}
                                                        xmlSpace="preserve"
                                                    >
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                        <path d="M8,9V1.8L0.9,8.8L0.2,8.1L7.3,1H0V0h9v9H8z" />
                                                    </svg>{" "}
                                                </span>
                                            </a>{" "}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                   
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demo;
